import React, { useEffect } from 'react';
import Resultatsbreadcrumbs from './SearchBreadcrumb';
import SearchResults from './SearchResults';

function MainSearchPage() {
	useEffect(() => {
	  window.scrollTo({ top: 0, behavior: "smooth" });
	}, []);
	
  return (
	  <main>
	  <Resultatsbreadcrumbs/>
	  <SearchResults/>
	  </main>
  )
}
export default MainSearchPage;
